import React from 'react';

const Instagram = () => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8131 4.63214C15.8131 5.22275 15.3263 5.70959 14.7357 5.70959C14.1451 5.70959 13.6582 5.22275 13.6582 4.63214C13.6582 4.04154 14.1451 3.55469 14.7357 3.55469C15.3263 3.55469 15.8131 4.03356 15.8131 4.63214Z"
        fill="white"
      />
      <path
        d="M9.81915 4.9668C7.27316 4.9668 5.20605 7.03391 5.20605 9.5799C5.20605 12.1259 7.27316 14.193 9.81915 14.193C12.3651 14.193 14.4322 12.1259 14.4322 9.5799C14.4402 7.04189 12.3651 4.9668 9.81915 4.9668ZM9.81915 12.5888C8.16705 12.5888 6.81824 11.24 6.81824 9.58788C6.81824 7.93578 8.16705 6.58697 9.81915 6.58697C11.4712 6.58697 12.8201 7.93578 12.8201 9.58788C12.8201 11.24 11.4792 12.5888 9.81915 12.5888Z"
        fill="white"
      />
      <path
        d="M13.5066 0.186523H5.98038C2.87572 0.186523 0.345703 2.71654 0.345703 5.82121V13.3474C0.345703 16.4521 2.87572 18.9821 5.98038 18.9821H13.5066C16.6113 18.9821 19.1413 16.4521 19.1413 13.3474V5.82121C19.1493 2.71654 16.6192 0.186523 13.5066 0.186523ZM17.4253 13.3554C17.4253 15.5183 15.6695 17.2741 13.5066 17.2741H5.98038C3.8175 17.2741 2.06165 15.5183 2.06165 13.3554V5.82919C2.06165 3.6663 3.8175 1.91045 5.98038 1.91045H13.5066C15.6695 1.91045 17.4253 3.6663 17.4253 5.82919V13.3554Z"
        fill="white"
      />
    </svg>
  );
};
export default Instagram;
